import React from 'react';
import { Link } from 'react-router-dom';
import civitasLogo from '../assets/images/Civitas Signals-small.png';
import googlePlayImage from '../assets/images/google-play.png';
import appleStoreImage from '../assets/images/apple-store.png';
import { onAppStoreClick } from '../utils/metaPixel';

const GOOGLE_PLAY_URL =
  process.env.REACT_APP_GOOGLE_PLAY_URL ??
  'https://play.google.com/store/apps/details?id=com.safescope.app&utm_source=na_Med';
const APP_STORE_URL = 'https://apps.apple.com/us/app/consilium-safety/id6760517718';
const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL ?? 'https://youtube.com/@consilium-app';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-section">
        <img src={civitasLogo} alt="Civitas Signals" className="footer-logo" />
        <p>Protecting families with real-time local intelligence.</p>
        <div className="footer-social">
          <a href="https://x.com/civitas_signals" aria-label="Twitter">𝕏</a>
          <a href="https://www.linkedin.com/company/civitas-signals/" aria-label="LinkedIn">in</a>
          <a href="https://www.facebook.com/people/Civitas-Signals/61583581006807/" aria-label="Facebook">f</a>
          <a
            href={YOUTUBE_CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="footer-social-youtube"
          >
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.4 31.4 0 0 0 24 12a31.4 31.4 0 0 0-.5-5.8zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="footer-section footer-links-section">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/features">Features</Link>
          <Link to="/breaking-news-problem">Breaking News Problem</Link>
          <Link to="/public-safety-data">Safety Data Guide</Link>
          <a href="/hazards/earthquakes/">Weekly Earthquake Report</a>
          <a href="/hazards/chemical-incidents/">Weekly Chemical Incidents Report</a>
          <a href="/crime/">Weekly US Crime Report</a>
          <Link to="/health-environmental-data">Health &amp; Environment</Link>
          <Link to="/faq">FAQ</Link>
          <a href="/privacy.html">Privacy Policy</a>
          <a href="/account-deletion.html">Account Deletion</a>
        </div>
      </div>
    </div>

    <div className="footer-bottom">
      <p>&copy; {new Date().getFullYear()} Civitas Signals, Inc. All rights reserved.</p>
      <div className="store-buttons">
        <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Get Consilium on Google Play"
          onClick={onAppStoreClick('android', { placement: 'footer' })}
        >
          <img src={googlePlayImage} alt="Google Play" className="store-icon" />
        </a>
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download Consilium on the App Store"
          onClick={onAppStoreClick('ios', { placement: 'footer' })}
        >
          <img src={appleStoreImage} alt="Download on the App Store" className="store-icon" />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
